import { OfficeWithdrawalRequestWithdrawalForm } from '@/context/services/office_withdrawal/type';

export const officeWithdrawalDefaultValues: OfficeWithdrawalRequestWithdrawalForm =
  {
    confirmed: false,
    question_1: false,
    question_2: false,
    question_3: false,
    question_3_text: '',
    question_4: false,
    question_4_text: '',
    question_5: false,
    question_5_text: '',
  };
